import React, { useState } from 'react';

const FALLBACK_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
    <line x1="14" y1="4" x2="10" y2="20"/>
  </svg>
);

/**
 * Logo: load from public/logo.png.
 * Put your logo at: frontend/public/logo.png then run npm run build.
 */
export function Logo({ className = 'logo-icon' }) {
  const [failed, setFailed] = useState(false);
  const logoSrc = `${process.env.PUBLIC_URL || ''}/logo.png`;

  if (failed) {
    return (
      <div className={className} aria-hidden="true">
        {FALLBACK_SVG}
      </div>
    );
  }

  return (
    <div className={className}>
      <img
        src={logoSrc}
        alt="GV-Security"
        className="logo-img"
        onError={() => setFailed(true)}
      />
    </div>
  );
}

export default Logo;
